module.exports = __webpack_public_path__ + "static/media/education3.3419f93c.png";